import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { docTypeSerializer } from "../anyDoc";

export const recentlyViewedEntrySerializer = Serializers.object({
  docId: Serializers.string,
  docType: docTypeSerializer,
  viewedAt: Serializers.datetime,
});

export type RecentlyViewedEntry = SerializerValue<typeof recentlyViewedEntrySerializer>;

export const recentlyViewedActions = {
  recordView: HttpAction({
    path: "/recentlyViewed",
    method: "put",
    requiresAuth: true,
    bodySerializer: Serializers.object({
      docId: Serializers.string,
      docType: docTypeSerializer,
    }),
  }),

  getRecentlyViewed: HttpAction({
    path: "/recentlyViewed",
    method: "get",
    requiresAuth: true,
    qsSerializer: Serializers.object({
      limit: Serializers.integer,
    }).partial(),
    valueSerializer: recentlyViewedEntrySerializer.array(),
  }),
};
